import { createContext, useContext } from 'react';
import type { useAccountCreateForm } from 'modules/account/create/useAccountCreateForm';
import type { StepConfig, StepConfigs } from 'modules/account/create/steps/stepsConfig';

export type AccountCreateForm = ReturnType<typeof useAccountCreateForm>;

const AccountCreateContext = createContext<AccountCreateForm | null>(null);

export function useAccountCreateContext(): AccountCreateForm {
  const ctx = useContext(AccountCreateContext);
  if (!ctx) throw new Error('useAccountCreateContext must be used within AccountCreateProvider');
  return ctx;
}

export const AccountCreateProvider = AccountCreateContext.Provider;
export type { StepConfig, StepConfigs };
